import { render, staticRenderFns } from "./AboutSideNav.vue?vue&type=template&id=2138dcc6&scoped=true&"
import script from "./AboutSideNav.vue?vue&type=script&lang=js&"
export * from "./AboutSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AboutSideNav.vue?vue&type=style&index=0&id=2138dcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138dcc6",
  null
  
)

export default component.exports